// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientInfo_root__2EVMY","info":"PatientInfo_info__1HsoJ"};